import styled from 'styled-components';

const IconWrapper = styled.div`
  display: flex;
  width: 100%;
  transition: all 0.3s;
  
  svg {
    width: 100%;
  }
`;

export default IconWrapper;
